module.exports = {
  'account.footer.copyright': '© 2018 - 2019 Binance.org. Seluruh hak cipta.',
  'account.footer.copyright.trubi': '© 2018 - 2019 Trubi. Seluruh hak cipta.',
  'account.footer.exchange': 'Bursa',
  'account.footer.home': 'Beranda',
  'balances.filteredByAsset': 'Difilter menurut aset',
  'balances.hideZeroBalance': 'Sembunyikan Saldo Nol',
  'balances.myBalances': 'Saldo Saya',
  'blocked.country.list':
    "Amerika Serikat, Albania, Bosnia dan Herzegovina, Belarus, Kongo (DRC), Côte d'Ivoire, Krimea, Kuba, Irak, Iran, Korea Utara, Liberia, Makedonia, Myanmar, Serbia, Sudan, Suriah, Zimbabwe.",
  'common.cancel': 'Batal',
  'common.close': 'Tutup',
  'common.confirm': 'Konfirmasi ',
  'common.connect': 'Hubungkan',
  'common.continue': 'Teruskan',
  'common.errorOccured': 'terjadi kesalahan',
  'common.goBack': 'Kembali',
  'common.googleUnlock': 'Google Drive',
  'common.keystoreFile': 'File Keystore',
  'common.ledgerDevice': 'Perangkat Ledger',
  'common.loading': 'Loading',
  'common.mnemonicPhrase': 'Frasa Pemulihan',
  'common.networkError': 'Jaringan Error',
  'common.or': 'atau',
  'common.password': 'Sandi',
  'common.placeOrder': 'Masukkan Order',
  'common.pleaseCheckVisitWebsite': 'Mohon periksa bahwa Anda mengunjungi ',
  'common.previous': 'Sebelum',
  'common.privateKey': 'Kunci Privat',
  'common.systemError': 'Sistem Error',
  'common.trezorDevice': 'Perangkat Trezor',
  'common.viewMyPrivateKey': 'Lihat Kunci Privat Saya',
  'common.viewOnly': 'Hanya Lihat',
  'common.walletConnect': 'Dompet Ponsel',
  'common.yes': 'Ya',
  'common.warning': 'Warning',
  'create.backupKeystore.backupYour': 'Cadangkan ',
  'create.backupKeystore.cannotRecoveredIt':
    'Tidak dapat dipulihkan jika Anda kehilangan hal tersebut.',
  'create.backupKeystore.createBackupFile': 'Buat cadangan pada file ini!',
  'create.backupKeystore.downloadKeystoreFile': 'Unduh File Keystore (UTC/JSON)',
  'create.backupKeystore.getMyPrivateKey': 'Dapatkan Kunci Privat Saya',
  'create.backupKeystore.keystoreFile': 'File Keystore',
  'create.backupKeystore.needFirstDownload': 'Anda harus mengunduh file keystore terlebih dahulu',
  'create.backupKeystore.notShareFile':
    'Jangan membagikan atau menggunakan file ini di situs web apa pun yang tidak diverifikasi. Dana Anda berpotensi dicuri.',
  'create.backupMnemonic.note':
    'Cadangkan teks di bawah ini di atas kertas serta simpan di tempat rahasia dan aman.',
  'create.backupMnemonic.title': 'Harap cadangkan mnemonic',
  'create.backupText':
    'Cadangkan teks di bawah ini di atas kertas dan simpan di tempat rahasia dan aman.',
  'create.chooseKSOrMnemonic.keystoreAndPassword': 'File Keystore + Sandi',
  'create.chooseKSOrMnemonic.keystoreFile': 'File Keystore',
  'create.chooseKSOrMnemonic.recommendedUSBDrive':
    'Disarankan untuk melakukan pencadangan di drive USB',
  'create.chooseKSOrMnemonic.recommendedUSBDriveOrPaper':
    'Direkomendasikan untuk melakukan pencadangan di kertas atau pada drive USB',
  'create.chooseKSOrMnemonic.title': 'Bagaimana cara membuat dompet baru yang Anda inginkan?',
  'create.chooseKSOrMnemonic.unlockExistWallet': 'Buka Dompet yang Ada',
  'create.chooseKSOrMnemonic.useKeystoreFile':
    'Gunakan File Keystore Anda (UTC / JSON) + Sandi untuk mengakses dompet Anda',
  'create.chooseKSOrMnemonic.useMnemonicPhrase':
    'Gunakan Frasa Mnemonik 24 kata yang Anda miliki untuk mengakses dompet Anda',
  'create.confirmNote': 'Apakah Anda yakin telah mencatat Frase Mnemonic Anda?',
  'create.createNewWallet': 'Buat Dompet Baru',
  'create.doubleConfirmMnemonic.note':
    'Silakan pilih Frase Mnemonik dalam urutan yang benar untuk memastikan bahwa salinan Anda benar.',
  'create.doubleConfirmMnemonic.title': 'Pilih Akses Sekunder',
  'create.doubleConfirmMnemonic.tryAgain': 'Urutan Frase Mnemonic salah. Silakan coba lagi.',
  'create.downloadKeyStoreFile': 'Unduh File Keystore',
  'create.enterPassword': 'Masukkan Sandi',
  'create.google.createWallet': 'Buat dompet',
  'create.google.createdSuccessfully': 'Pembuatan Dompet Berhasil',
  'create.google.creationFailure': 'Pembuatan Dompet Salah',
  'create.google.tryAgain': 'Coba kembali',
  'create.google.walletName': 'Nama dompet',
  'create.googledrive.rePassErr': 'Sandi yang dimasukkan tidak cocok',
  'create.keystoreFileAndPassword': 'Buat File Keystore + Sandi',
  'create.pick.useGoogleDrive.description': 'Buat dompet baru menggunakan akun Google Anda',
  'create.pick.useGoogleDrive.title': 'Menggunakan Google Drive',
  'create.pick.useLocalKeystore.description':
    'Buat dompet baru yang dapat Anda simpan pada perangkat',
  'create.pick.useLocalKeystore.title': 'Menggunakan File Keystore',
  'create.pleaseCheck': 'Harap periksa bahwa Anda mengunjungi ',
  'create.reEnterPassword': 'Masukkan kembali Sandi',
  'create.stepTwo.desc':
    'Kami akan menunjukkan frasa mnemonik Anda, pastikan tidak ada orang lain yang melihat layar Anda.',
  'create.success.desc1': 'Anda siap menggunakan Dompet Binance Chain dan',
  'create.success.desc2': 'Bursa Desentralisasi!',
  'create.success.title': 'Anda telah siap!',
  'create.success.unlockWallet': 'Buka dompet',
  'create.tutorial.next': 'Selanjutnya',
  'create.tutorial.skip': 'Lewati Tutorial (Tidak Disarankan)',
  'create.tutorial.step1.desc1':
    'Binance berkomitmen untuk memberikan Anda pengalaman terbaik dan teraman di Binance Chain. Untuk melakukan itu, kami meminta waktu Anda sebentar untuk memahami bagaimana dompet terdesentralisasi bekerja dan untuk mengambil tindakan dalam melindungi diri Anda sendiri. Anda dapat menemukan Ketentuan Layanan lengkap di sini.',
  'create.tutorial.step1.title': 'Komitmen Kami',
  'create.tutorial.step2.desc1':
    'Anda bertanggung jawab penuh untuk menyimpan dana Anda. Tidak ada orang lain, bahkan Binance, yang dapat membantu Anda memulihkan dompet Anda jika hilang.',
  'create.tutorial.step2.desc2':
    'Saat Anda membuat dompet di Binance, Anda diberikan 3 format berbeda, masing-masing dapat digunakan untuk mengakses dompet Anda.',
  'create.tutorial.step2.title': 'Menyimpan Dana Anda',
  'create.tutorial.step3.desc1':
    'Anda dapat menganggap file keystore seperti \n"ID Pengguna", sementara sandi untuk membuka dompet Anda. Keduanya diperlukan untuk mengakses dompet Anda, jadi jaga agar tetap aman. Ini adalah format yang diperlukan pada Binance.',
  'create.tutorial.step3.title': 'File Keystore + Sandi',
  'create.tutorial.step4.desc1':
    '24 kata yang merupakan "User ID" dan sandi. Ini adalah cara sekunder untuk mengakses dompet Anda jika Anda kehilangan file keystore Anda atau lupa sandi Anda. Siapa pun yang tahu frasa mnemonik Anda dapat mengakses dompet Anda, jadi amankan itu.',
  'create.tutorial.step4.title': 'Frasa Mnemonic',
  'create.tutorial.step5.desc1': 'Ini adalah representasi alternatif dari kata fase mnemonik.',
  'create.tutorial.step5.desc2':
    'Binance mengharuskan semua pengguna untuk menggunakan file Keystore + sandi; Dan memilih antara frasa mnemonik atau kunci pribadi sebagai metode sekunder.',
  'create.tutorial.step5.title': 'Kunci privat',
  'create.tutorial.title': 'Tutorial Pembuatan Dompet',
  'create.tutorial.understand': 'Saya Mengerti',
  'create.understandCheckbox':
    'Saya mengerti bahwa Binance tidak dapat memulihkan atau mereset kata sandi atau file keystore saya. Saya akan membuat cadangan file keystore/sandi, merahasiakannya, selesaikan semua langkah pembuatan dompet dan setujui semua ',
  'create.understandCheckbox.terms': 'ketentuan',
  'create.unlockExistWallet': 'Buka Dompet yang Ada',
  'create.yourKeyStore': 'Keystore Anda',
  'editWallet.remove': 'Hapus',
  'editWallet.remove.desc1': 'Mohon periksa bahwa tidak ada uang yang terdapat pada dompet',
  'editWallet.remove.desc2': 'karena tidak ada cara untuk memulihkan dompet',
  'editWallet.remove.removeButton': 'Ya, hapus dompet ini',
  'editWallet.remove.title': 'Anda benar-benar yakin untuk menghapus dompet ini?',
  'editWallet.rename': 'Penamaan kembali',
  'editWallet.rename.duplicateName': 'Nama dompet sudah ada',
  'editWallet.rename.errMsg': 'Nama tidak boleh kosong',
  'editWallet.rename.title': 'Nama dompet',
  'editWallet.title': 'Nama Dompet',
  'editWallet.createWallet': 'Buat Dompet',
  'editWallet.unlockWallet': 'Buka Dompet',
  'exchange.BTCValue': 'Nilai BTC',
  'exchange.amount': 'Jumlah',
  'exchange.asset': 'Aset',
  'exchange.availableBalance': 'Saldo Tersedia',
  'exchange.blockHeight': 'Ketinggian Block',
  'exchange.buy': 'Beli',
  'exchange.calendar.clear': 'Hapus',
  'exchange.calendar.ok': 'Ok',
  'exchange.calendar.today': 'Hari ini',
  'exchange.chartbox.depth': 'Depth',
  'exchange.coin': 'Koin',
  'exchange.date': 'Tanggal',
  'exchange.estimatedValue': 'Estimasi Nilai',
  'exchange.filled': 'Isi',
  'exchange.from': 'Dari',
  'exchange.frozen': 'Bekukan',
  'exchange.hideAllCanceled': 'Sembunyikan semua pembatalan',
  'exchange.hideOtherPairs': 'Sembunyikan Pasangan Lainnya',
  'exchange.inOrder': 'In Order',
  'exchange.index.books': 'Book',
  'exchange.index.chart': 'Grafik',
  'exchange.max': 'Maks',
  'exchange.min': 'Minimal unit perdagangan:',
  'exchange.name': 'Nama',
  'exchange.notional': 'Notional',
  'exchange.oneDay': '1 Hari',
  'exchange.oneMonth': '1 Bulan',
  'exchange.oneWeek': '1 Minggu',
  'exchange.pair': 'Pasangan',
  'exchange.placeOrder.bestAsk': 'Permintaan Terbaik',
  'exchange.placeOrder.bestBid': 'Penawaran Terbaik',
  'exchange.placeOrder.limitOrder': 'Limit Order',
  'exchange.placeOrder.noEnoughBalance': 'saldo tidak mencukupi',
  'exchange.placeOrder.orderError': 'Order Error',
  'exchange.placeOrder.orderPriceHigher':
    'Harga Order Anda akan 2% lebih tinggi dari harga pasar terbaru. Silakan lanjutkan dengan hati-hati.',
  'exchange.placeOrder.orderPriceLow':
    'Harga order Anda akan 2% lebih rendah dari harga pasar terbaru. Silahkan lanjutkan dengan hati-hati.',
  'exchange.placeOrder.pleaseInputCorrectAmount': 'silahkan masukkan jumlah yang benar',
  'exchange.placeOrder.pleaseInputCorrectPrice': 'silahkan masukkan harga yang benar',
  'exchange.placeOrder.roundSizeErrorMsg':
    'Anda hanya dapat {side} {baseAsset} dalam kelipatan {lotSize}',
  'exchange.placeOrder.successNotifyMsg':
    'Anda telah berhasil membuat batas pesanan ke {side} {kuantitas} {quoteAsset}',
  'exchange.placeOrder.successNotifyTitle': 'Limit {side} Order Dibuat',
  'exchange.pleaseSelectDate': 'silahkan pilih tanggal',
  'exchange.pleaseUnlockWallet.btn': 'Buka Dompet',
  'exchange.pleaseUnlockWallet.createNewWallet': 'Buat Dompet Baru',
  'exchange.pleaseUnlockWallet.desc': 'Ups! Silahkan buka dompet Anda terlebih dahulu',
  'exchange.pleaseUnlockWallet.noWallet': 'Tidak ada Dompet?',
  'exchange.price': 'Harga',
  'exchange.search': 'Pencarian',
  'exchange.sell': 'Jual',
  'exchange.side': 'Side',
  'exchange.status': 'Status',
  'exchange.symbolPriceInfo.high': 'Tinggi',
  'exchange.symbolPriceInfo.lastPrice': 'Harga Terakhir',
  'exchange.symbolPriceInfo.low': 'Rendah',
  'exchange.symbolPriceInfo.twentyFourHChange': '24jam Change',
  'exchange.symbolPriceInfo.twentyFourHHigh': '24jam Tinggi',
  'exchange.symbolPriceInfo.twentyFourHLow': '24jam Rendah',
  'exchange.symbolPriceInfo.twentyFourHVolume': 'Volume 24jam',
  'exchange.symbolPriceInfo.vol': 'Vol',
  'exchange.threeMonths': '3 Bulan',
  'exchange.time.from': 'Dari',
  'exchange.to': 'Untuk',
  'exchange.total': 'Total',
  'exchange.totalBalance': 'Total Saldo',
  'exchange.tradingHistory.time': 'Waktu',
  'exchange.tradingHistory.title': 'Riwayat Perdagangan',
  'exchange.tradingPair.change': 'Change',
  'exchange.tradingPair.pair': 'Pasangan',
  'exchange.tradingPair.price': 'Harga',
  'exchange.tradingPair.search': 'Pencarian',
  'exchange.tradingPair.volume': 'Volume',
  'exchange.txFee': 'Biaya Transaksi',
  'exchange.txHash': 'Hash Transaksi',
  'exchange.type': 'Tipe',
  'exchange.value': 'Nilai',
  'fees.fee': 'Biaya',
  'fees.height': 'Ketinggian',
  'fees.note': 'Catatan',
  'footer.terms': 'Ketentuan Layanan',
  'footer.privacy': 'Privacy',
  'googledrive.create.nameExist': 'Nama sudah ada',
  'header.balances': 'Saldo',
  'header.createWallet': 'Buat Dompet',
  'header.exchange': 'Bursa',
  'header.explorer': 'Explorer',
  'header.faq': 'Dokumen / FAQ',
  'header.feeHistory': 'Riwayat Biaya',
  'header.forums': 'Forum',
  'header.mainnet': 'Mainnet',
  'header.openOrders': 'Order Terbuka',
  'header.orderHistory': 'Riwayat Order',
  'header.orders': 'Order',
  'header.testnet': 'testnet',
  'header.tradeHistory': 'Riwayat Perdagangan',
  'header.transactions': 'Transaksi',
  'header.unlockWallet': 'Buka Dompet',
  'header.user.changeWallet': 'Ubah Dompet',
  'header.user.closeWallet': 'Tutup Dompet',
  'header.user.coinomi': 'Coinomi ',
  'header.user.copyAddress': 'salin alamat',
  'header.user.copySuccess': 'Sukses menyalin!',
  'header.user.createNewWallet': 'Buat Dompet Baru',
  'header.user.exportKeystoreFile': 'Ekspor File Keystore',
  'header.user.goToExplorer': 'menuju ke explorer',
  'header.user.infinito': 'Infinito ',
  'header.user.ledger': 'Ledger ',
  'header.user.trezor': 'Perangkat Trezor',
  'header.user.wallet': 'Dompet',
  'header.user.walletConnect': 'WalletConnect ',
  'header.youWantCloseWallet': 'Anda yakin ingin menutup dompet?',
  'home.aboutPage.desc1.line1':
    'Binance Chain adalah blockchain yang awalnya dikembangkan oleh Binance.',
  'home.aboutPage.desc1.line2':
    'Ini modern, aman dan memiliki finalitas transaksi hampir instan (cepat).',
  'home.aboutPage.desc2.line1': 'Binance DEX adalah mesin pencocokan pesanan desentralisasi,',
  'home.aboutPage.desc2.line2': 'ditenagai oleh teknologi inti Binance Chain.',
  'home.aboutPage.desc3.line1': 'Binance DEX adalah pasar modern dan aman untuk penerbitan',
  'home.aboutPage.desc3.line2':
    'dan bertukar aset digital, dan tidak ada orang lain selain Anda yang memegang kunci Anda. Perdagangan aset favorit Anda tidak pernah lebih aman.',
  'home.aboutPage.title': 'Tentang Binance DEX',
  'home.binanceDex': 'Binance DEX',
  'home.processPage.aboutBalance': 'Tentang Binance DEX',
  'home.processPage.create': 'Buat',
  'home.processPage.createDesc': 'Langkah pertama adalah membuat alamat Binance Chain.',
  'home.processPage.createWallet': 'Buat Dompet Baru',
  'home.processPage.getStart': 'Mulai dengan Binance DEX',
  'home.processPage.go': 'Menuju',
  'home.processPage.placeOrders': 'Masukkan Order',
  'home.processPage.placeOrdersDesc':
    'Gunakan dompet web atau API untuk mengirim dan membatalkan order.',
  'home.processPage.transferAssets': 'Transfer Aset',
  'home.processPage.transferAssetsDesc':
    'Dengan alamat Binance Chain, yang dapat dibuat dengan dompet apa pun yang mendukung Binance Chain, Anda dapat mentransfer BNB atau aset lain yang tersimpan di alamat tersebut.',
  'home.processPage.unlock': 'Buka',
  'home.processPage.unlockDesc': 'Empat cara untuk membuka dompet Anda',
  'home.processPage.unlockMode1': 'WalletConnect',
  'home.processPage.unlockMode2': 'Ledger',
  'home.processPage.unlockMode3': 'File Keystore + Sandi',
  'home.processPage.unlockMode4': 'Mnemonic',
  'home.processPage.unlockWallet': 'Buka sebuah Dompet',
  'home.startPage.createWallet': 'Buat sebuah Dompet',
  'home.startPage.desc1': 'Pertukaran aset digital desentralisasi yang cepat dan aman',
  'home.startPage.desc2': 'Standar perdagangan mata uang digital baru ada di sini.',
  'home.startPage.getTestBNB': 'Dapatkan Tes BNB',
  'home.startPage.startTrading': 'Mulai Trading',
  'home.whyPage.community': 'Ini adalah Inisiatif Komunitas',
  'home.whyPage.communityDesc':
    'Binance DEX didukung oleh tata kelola on-chain dan komponen open source perangkat lunak.',
  'home.whyPage.decentralized': 'Desentralisasi',
  'home.whyPage.decentralizedDesc':
    'Rasakan pengalaman langsung dompet ke dompet perdagangan tanpa pihak ketiga atau otoritas pusat.',
  'home.whyPage.getStarted': 'Mulai',
  'home.whyPage.lowTradingFees': 'Biaya Trading Rendah',
  'home.whyPage.lowTradingFeesDesc':
    'Berdagang tanpa biaya penarikan, setoran, atau penempatan order - dan pemegang BNB mendapat manfaat lebih besar.',
  'home.whyPage.safeAndSecure': 'Aman dan Terjamin',
  'home.whyPage.safeAndSecureDesc':
    'Dana Anda disimpan pada alamat blockchain dengan kunci pribadi yang hanya Anda yang dapat mengendalikan.',
  'home.whyPage.title': 'Kenapa Binance DEX',
  'home.whyPage.userFriendly': 'Ramah Pengguna',
  'home.whyPage.userFriendlyDesc':
    'Buat dompet, buka dompet Anda, dan Anda siap berdagang. Tidak perlu melakukan setoran atau penarikan.',
  'inputPassword.passwordRule': 'Sandi Anda harus menyertakan properti berikut',
  'inputPassword.passwordRule1': '8 karakter atau lebih',
  'inputPassword.passwordRule2': 'Huruf besar, simbol, dan angka',
  'inputPassword.setANewPassword': 'Buat Sandi Baru',
  'landing.connectWallet': 'Hubungkan Dompet',
  'landing.createWallet': 'Buat Dompet',
  'landing.desc1': 'Binance DEX',
  'landing.desc2':
    'Pertukaran aset digital terdesentralisasi yang cepat dan aman. Standar perdagangan mata uang kripto yang baru ada di sini.',
  'landing.footer.fee': 'Biaya',
  'landing.footer.terms': 'Ketentuan Layanan',
  'landing.footer.privacy': 'Privacy',
  'landing.how.connect': 'Hubungkan',
  'landing.how.connect.desc':
    'Mengakses Binance DEX lebih mudah dari yang Anda pikirkan. Klik tombol sambungkan dan pilih dari opsi koneksi. Anda sudah siap.',
  'landing.how.create': 'Buat',
  'landing.how.create.desc':
    'Binance DEX memberi Anda kebebasan untuk memilih dari keystores yang nyaman hingga opsi dompet hardware yang sangat aman.',
  'landing.how.step': 'langkah',
  'landing.how.title': 'Bagaimana cara menggunakan',
  'landing.how.trade': 'Perdagangan',
  'landing.how.trade.desc':
    'Tujuan kami adalah membuat perdagangan menjadi lancar dan tidak dapat dibedakan dari Binance.com. Untuk melakukan itu, kami telah mengoptimalkan fitur terbaik sehingga semua yang Anda sukai juga ada di Binance DEX.',
  'landing.markets': 'Market',
  'landing.markets.24HChange': '24JAM Change',
  'landing.markets.24HVolume': 'Volume 24JAM',
  'landing.markets.lastPrice': 'Harga Terakhir',
  'landing.markets.pair': 'Pasangan',
  'landing.markets.searchPlaceholder': 'Cari nama koin',
  'landing.menu.balances': 'Saldo',
  'landing.menu.changeWallet': 'Ubah Dompet',
  'landing.menu.closeWallet': 'Tutup Dompet',
  'landing.menu.community': 'Komunitas',
  'landing.menu.copyAddress': 'salin alamat',
  'landing.menu.docs': 'Dokumen',
  'landing.menu.exchange': 'Bursa',
  'landing.menu.explorer': 'Explorer',
  'landing.menu.orders': 'Order',
  'landing.menu.orders.feeHistory': 'Riwayat Biaya',
  'landing.menu.orders.openOrders': 'Order Terbuka',
  'landing.menu.orders.orderHistory': 'Riwayat Order',
  'landing.menu.orders.tradeHistory': 'Riwayat Perdagangan',
  'landing.menu.testnet': 'Testnet',
  'landing.menu.tools': 'Alat',
  'landing.menu.transaction': 'Transaksi',
  'landing.menu.wallet': 'Dompet',
  'landing.startTrading': 'Mulai Perdagangan',
  'landing.trust.activeAddress': 'Aktifkan Dompet',
  'landing.trust.activeAddress.desc':
    'Lebih banyak orang mempercayai infrastruktur dan sistem perdagangan Binance DEX daripada solusi dompet lainnya.',
  'landing.trust.pairs': 'Pasangan',
  'landing.trust.pairs.desc':
    'Binance DEX memberi Anda lebih banyak opsi dan fleksibilitas untuk berdagang, dengan lebih banyak ditambahkan setiap minggu.',
  'landing.trust.rank': 'Peringkat',
  'landing.trust.rank.desc':
    'Binance DEX adalah pertukaran mata uang digital desentralisasi #1 di Coinmarketcap berdasarkan volume.',
  'landing.trust.title': 'Kenapa orang mempercayai kami',
  'landing.why.competitive': 'Kompetitif',
  'landing.why.competitive.desc':
    'Biaya hanya 0,04% ketika Anda menggunakan BNB untuk membayar biaya perdagangan. Hal itu hampir setengah dari Binance.com, pertukaran terkemuka di dunia dalam biaya perdagangan.',
  'landing.why.fast': 'Cepat',
  'landing.why.fast.desc':
    'Dengan waktu blok 1 detik, konfirmasi perdagangan blockchain adalah sesuatu dari masa lalu. Dapatkan semua keuntungan dari DEX tanpa kerugian.',
  'landing.why.secure': 'Aman',
  'landing.why.secure.desc':
    'Binance DEX membawa keamanan ke tingkat yang sama sekali baru. Transfer dan perdagangan peer-to-peer artinya hampir tidak ada paparan ancaman keamanan.',
  'landing.why.title': 'Kenapa Binance DEX',
  'lang.menu.copyAddress': ' ',
  'noContent.descPrefix': 'Anda tidak memiliki ',
  'openOrders.areYourTrue': 'Anda yakin ingin untuk',
  'openOrders.cancel': 'batal',
  'openOrders.cancel all': 'batalkan semua',
  'openOrders.cancel buy': 'batalkan pembelian',
  'openOrders.cancel sell': 'batalkan penjualan',
  'openOrders.cancelAll': 'Batalkan semua',
  'openOrders.cancelBuy': 'Batalkan Pembelian',
  'openOrders.cancelOrder': 'Batalkan Order',
  'openOrders.cancelOrders': 'Batalkan Order',
  'openOrders.cancelPartialSuccess': 'Sukses membatalkan sebagian',
  'openOrders.cancelSell': 'Batalkan jual',
  'openOrders.cancelSuccess': 'Batalkan sukses',
  'openOrders.keepOrder': 'Simpan Order',
  'openOrders.keepOrders': 'Simpan Order',
  'openOrders.noBuyOpenOrders': 'tidak ada order beli terbuka',
  'openOrders.noOpenOrders': 'tidak ada order terbuka',
  'openOrders.noSellOpenOrders': 'tidak ada order jual terbuka',
  'openOrders.title': 'Order Terbuka',
  'orderForm.amount': 'Jumlah',
  'orderForm.avb': 'Avb',
  'orderForm.buy': 'Beli',
  'orderForm.equivalent': 'Ekuivalen',
  'orderForm.price': 'Harga',
  'orderForm.sell': 'Jual',
  'orderForm.total': 'Total',
  'orderHistory.openHistory': 'riwayat order',
  'orderHistory.title': 'Riwayat Order',
  'orderHistory.tradeId': 'ID Perdagangan',
  'orderHistory.tradingPrice': 'Harga Perdagangan',
  'orderHistory.tradingTotal': 'Total Perdagangan',
  'privateKeyModal.backupText':
    'Cadangkan teks di bawah ini di atas kertas dan simpan di tempat yang rahasia dan aman.',
  'privateKeyModal.title': 'Kunci Privat Anda',
  'testnet.binanceChainExplorerGuide': 'Panduan Penjelajah Binance Chain',
  'testnet.fastAndSecureDesc': 'Pertukaran aset digital desentralisasi yang cepat dan aman',
  'testnet.fundingYourTestnetAccount': 'Mendanai Akun Testnet Anda',
  'testnet.howToAccessYourWallet': 'Bagaimana cara Mengakses Dompet Anda',
  'testnet.howToCreateAWallet': 'Bagaimana cara Membuat Dompet',
  'testnet.interfaceGuide': 'Panduan Antarmuka',
  'testnet.thingsToAvoid': 'Hal-hal yang Harus Dihindari',
  'testnet.title': 'Binance Decentralized Exchange (TESTNET)',
  'token.issueModal.mintable': 'Dapat di cetak',
  'token.issueModal.name': 'Nama Token',
  'token.issueModal.nameErrMsg': 'nama token terbatas hingga 32 karakter',
  'token.issueModal.symbol': 'Simbol',
  'token.issueModal.symbolErrMsg': 'simbol harus alfanumerik dan panjang dibatasi hingga 3~8',
  'token.issueModal.title': 'Token Terbitan',
  'token.issueModal.totalSupply': 'Total Suplai',
  'token.issueModal.totalSupplyErrMsg': 'jumlah suplai tidak valid',
  'token.listModal.address': 'Alamat',
  'token.listModal.confirm': 'Konfirmasi',
  'token.listModal.initPrice': 'Harga Init',
  'token.listModal.proposalId': 'ProposalId',
  'token.listModal.quoteAsset': 'Penawaran Aset',
  'token.listModal.title': 'Daftar Token',
  'token.listModal.tokenName': 'Nama Token',
  'token.main.burn': 'Bakar',
  'token.main.freeze': 'Bekukan',
  'token.main.issueToken': 'Token Terbitan',
  'token.main.list': 'Daftar',
  'token.main.listSuccessmsg': 'Pendaftaran berhasil',
  'token.main.mint': 'Cetak',
  'token.main.proposal': 'Proposal',
  'token.main.submitListFirst': 'Silahkan masukkan daftar proposal terlebih dahulu',
  'token.main.submitSuccessmsg': 'sukses memasukkan list proposal',
  'token.main.title': 'Daftar Token Saya',
  'token.main.unfreeze': 'Cairkan',
  'token.proposalModal.address': 'Alamat',
  'token.proposalModal.baseAsset': 'Aset Dasar',
  'token.proposalModal.desc': 'Deskripsi',
  'token.proposalModal.expireTime': 'Waktu Kadaluarsa',
  'token.proposalModal.hours': 'Jam',
  'token.proposalModal.initDeposit': 'Setoran Awal',
  'token.proposalModal.initPrice': 'Harga Awal',
  'token.proposalModal.initPriceErr': 'Harga awal seharusnya tidak kosong (nol)',
  'token.proposalModal.initPriceErr2': 'harga awal harus lebih besar dari 0',
  'token.proposalModal.quoteAsset': 'Aset Kutipan',
  'token.proposalModal.title': 'Daftar Proposal',
  'token.proposalModal.titleErr': 'Judul proposal tidak boleh nol',
  'token.proposalModal.titleErr2': 'Judul proposal lebih panjang dari maksimal 128',
  'token.proposalModal.votingPeriod': 'Periode Voting',
  'token.table.col.mintable': 'Dapat di cetak',
  'token.table.col.name': 'Nama',
  'token.table.col.symbol': 'Simbol',
  'token.table.col.totalSupply': 'Total Suplai',
  'token.tokenModal.address': 'Alamat',
  'token.tokenModal.amount': 'Jumlah',
  'token.tokenModal.available': 'Tersedia',
  'token.tokenModal.burnTitle': 'Bakar Token',
  'token.tokenModal.confirm': 'Konfirmasi',
  'token.tokenModal.desc': ' ',
  'token.tokenModal.freezeTitle': 'Bekukan Token',
  'token.tokenModal.mintTitle': 'Cetak Token',
  'token.tokenModal.name': 'Nama',
  'token.tokenModal.unfreezeTitle': 'Cairkan Token',
  'token.warning':
    'We do not support walletconnect compatible wallets currently and for security reason, Ledger is the best choice to Issue/List/Mint/Burn Token',
  'tradeHistory.tradeHistory': 'riwayat perdagangan',
  'transaction.here': 'di sini',
  'transaction.notes':
    'Tidak semua transaksi termasuk di bawah. Untuk riwayat lengkapnya silahkan menuju',
  'txHistory.here': 'di sini',
  'txHistory.notEveryTransactionIsIncludedBelow':
    'Tidak setiap transaksi termasuk di bawah ini. Untuk riwayat lengkap, silakan lihat di sini.',
  'txHistory.title': 'Riwayat Transaksi',
  'unlock.connectAddress.enterYourAddress': 'Masukkan Alamat Anda',
  'unlock.connectAddress.invalidAddress': 'Alamat tidak sah',
  'unlock.connectAddress.viewOnlyMode': 'Masukkan alamat untuk mode tampilan saja',
  'unlock.createNewWallet': 'Buat Dompet Baru',
  'unlock.google.chooseWallet': 'Pilih dari dompet Anda yang tersedia:',
  'unlock.google.logIn': 'Masuk',
  'unlock.google.notLoggedIn': 'Anda belum masuk pada Akun Google Anda',
  'unlock.google.signedInAs': 'Anda masuk sebagai',
  'unlock.googledrive.editWallet': 'Edit Detail Dompet',
  'unlock.googledrive.wallets': 'Pilih dari dompet Anda untuk melanjutkan:',
  'unlock.index.selectUnlockType': 'Pilih bagaimana anda akan membukanya',
  'unlock.index.title': 'Buka Dompet Anda',
  'unlock.keystore.enterYourWalletPass': 'Masukkan password dompet Anda',
  'unlock.keystore.paste': 'Atau tempelkan isi file keystore Anda',
  'unlock.keystore.select': 'Hubungkan file dompet terenkripsi dan masukkan sandi Anda',
  'unlock.keystore.upload': 'Unggah file keystore',
  'unlock.ledger.appInstallation': 'Instalasi Aplikasi',
  'unlock.ledger.binanceChainReady': 'Binance Chain Siap',
  'unlock.ledger.connectToLedger': 'Hubungkan ke Ledger',
  'unlock.ledger.enterPINCode': 'Masukkan Kode PIN',
  'unlock.ledger.getTheApp': 'Dapatkan Aplikasi',
  'unlock.ledger.havingConnectionIssues': 'Memiliki Masalah Koneksi?',
  'unlock.ledger.mustBeOnScreen': 'harus di layar',
  'unlock.ledger.openBinanceChain': 'Buka Binance Chain',
  'unlock.ledger.text':
    'Hubungkan dompet hardware Anda di sini dengan mengikuti instruksi di layar',
  'unlock.ledger.title': 'Buka dengan Perangkat Ledger',
  'unlock.ledger.usageInstructions': 'Petunjuk Penggunaan',
  'unlock.mnemonic.pleaseEnterYourPhrase': 'Silakan masukkan frasa 24 kata Anda',
  'unlock.mnemonic.pleaseSeparateEachWordSpace': 'Mohon pisahkan setiap kata dengan spasi.',
  'unlock.mnemonic.warning.desc1': 'Opsi ini mengembalikan file keystore atau sandi yang hilang,',
  'unlock.mnemonic.warning.desc2': 'atau mengimpor seed dari aplikasi dompet lain.',
  'unlock.mnemonic.warning.desc3':
    'Peringatan! Memasukkan frase awal atau kunci privat di situs web apa pun sangat berbahaya. Jika Anda memasang ekstensi jahat di peramban atau secara tidak sengaja mengunjungi situs web phishing, aset Anda dapat dicuri.',
  'unlock.privateKey.enterYourPrivateKey': 'Masukkan kunci pribadi Anda (format hex)',
  'unlock.privateKey.invalid':
    'Kunci Pribadi yang Anda masukkan tidak dalam format yang benar dan tidak valid. Silakan coba lagi.',
  'unlock.privateKey.passwordInvalid': 'Sandi tersebut tidak valid. Silakan coba lagi.',
  'unlock.privateKey.warning': 'Untuk memulihkan file atau sandi yang hilang',
  'unlock.privateKey.warningQuestion':
    'Memasukkan kunci privat Anda di situs web apapun sangat berbahaya. Jika Anda memasang ekstensi jahat di peramban atau secara tidak sengaja mengunjungi situs web phishing, aset Anda dapat dicuri.',
  'unlock.recover.content':
    'Pulihkan akses dompet menggunakan frasa pemulihan yang diketahui selama pembuatan dompet',
  'unlock.recover.download.button': 'Unduh',
  'unlock.recover.downloadTitle': 'Unduh File Keystore Anda',
  'unlock.recover.password.placeholder': 'Masukkan sandi yang kuat',
  'unlock.recover.submit': 'Masukkan',
  'unlock.recover.title': 'Pulihkan File Keystore',
  'unlock.recover.understand.continue': 'Pulihkan File Keystore',
  'unlock.recover.word.placeholder': 'Pencarian',
  'unlock.recover.wordlist.reset': 'Setel Ulang',
  'unlock.recover.wordlistTitle': 'Silakan pilih Frasa Mnemonik Anda dari daftar kiri',
  'unlock.support.wallets': ' ',
  'unlock.temporarySessionPassword': 'Sandi sesi sementara',
  'unlock.thisIsNotAValidWalletFile': 'Ini bukan file dompet yang valid',
  'unlock.trezor.connectToTrezor': 'Hubungkan ke Trezor',
  'unlock.trezor.firmwareNotice':
    'Catatan: Pastikan Anda telah memperbarui ke firmware Trezor terbaru untuk menggunakan perangkat Anda dengan Binance Chain.',
  'unlock.trezor.notOnTestNet':
    'Catatan: Perangkat Trezor membutuhkan Chrome atau Firefox sekarang juga ',
  'unlock.trezor.title': 'Buka dengan Perangkat Trezor',
  'unlock.unlockWalletNow': 'Buka Dompet Sekarang',
  'unlock.walletConnect.notes':
    'Catatan: Trust Wallet dan CoolWallet tidak mendukung Binance Chain Testnet.',
  'unlock.walletConnect.recommendedWallet': 'Aplikasi yang didukung termasuk',
  'unlock.walletConnet.getTrustWallet': 'Dapatkan Trust Wallet',
  'unlock.walletConnet.qrCodeDesc1': 'Dapatkan Kode QR WalletConnect',
  'unlock.walletConnet.qrCodeDesc2': 'Belum memiliki aplikasi yang mendukung WalletConnect?',
  'unlock.walletConnet.showWalletQrCode':
    'Hubungkan dompet ponsel Anda di sini menggunakan kode QR pada layar ini',
  'unlock.walletConnet.title': 'Rekomendasi',
  'walletConnect.clickHereToUnlock': 'Klik di sini untuk membuka kunci dompet lain',
  'walletConnect.error': 'Kesalahan WalletConnect',
  'walletConnect.errorOccur': 'Telah terjadi error pada WalletConnect',
  'walletConnect.pleaseEnsureOpenWorking': 'Mohon pastikan bahwa aplikasi terbuka dan berfungsi.',
  'walletConnect.pleaseUseAWalletConnect':
    'Silakan gunakan aplikasi yang mendukung WalletConnect untuk memindai kode QR di atas',
  'walletConnect.qrCode': 'Kode QR WalletConnect',
  'walletConnect.readyToConfirm': 'Mohon Konfirmasi',
  'walletConnect.readyToConfirmBody': 'Harap konfirmasi transaksi di Aplikasi dompet.',
  'walletconnect.notifycation.connectAgain': 'Hubungkan kembali',
  'walletconnect.notifycation.disconnectMessage': ' Terputus dari Dompet Ponsel...',
  'walletconnect.notifycation.hide': 'Sembunyikan',
  'local.secure.storage': 'Local Secure Storage',
  'local.keystore.replace.tips':
    'You already have a keystore file, make sure you have backed up before replace',
}
